export const IS_GOOGLE = "google";
export const IS_FACEBOOK = "facebook";
